<template>
  <div class="relative w-full mr-2 sm:mr-4">
    <!-- Toggle display of summary -->
    <div class="flex justify-between">
      <PriceSummaryToggle :showSummary="showSummary"
                          v-on:toggleSummary="showSummary = !showSummary"></PriceSummaryToggle>
      <div :class="{ hidden: !showSummary }">
        <!-- Button to select which summary options to display -->
        <PriceSummaryMenu :options="availableOptions"></PriceSummaryMenu>
      </div>
    </div>
    <div class="flex flex-wrap" :class="{ hidden: !showSummary }">
      <div class="border border-gray-400 bg-gray-200 rounded px-3 py-2 mr-2 mb-2">
        <div class="text-xs text-gray-600 uppercase mb-1">Mark-up</div>
        <div class="text-xl relative w-16">
          <input  v-model="price.markup.rate"
                  type="number"
                  class="pr-5 inline-block w-full text-right border border-gray-400 rounded"
          >
          <span
            class="absolute right-1 text-gray-500 pointer-events-none"
          >%</span>
        </div>
      </div>
      <div class="border border-gray-400 bg-gray-200 rounded px-3 py-2 mr-2 mb-2">
        <div class="text-xs text-gray-600 uppercase mb-1">Tax</div>
        <div class="text-xl relative w-16">
          <input  v-model="price.tax.rate"
                  type="number"
                  class="pr-5 inline-block w-full text-right border border-gray-400 rounded"
          >
          <span
            class="absolute right-1 text-gray-500 pointer-events-none"
          >%</span>
        </div>
      </div>
      <!-- Display selected summary items -->
      <div class="border border-gray-400 bg-gray-200 rounded px-3 py-2 mr-2 mb-2"
           v-for="(option, index) in filteredOptions" :key="index">
        <PriceSummaryItem :option="option" :value="$store.getters[option.func]" :settings="settings"></PriceSummaryItem>
      </div>

    </div>

  </div>
</template>

<script>
import { mapState } from 'vuex'
import PriceSummaryToggle from '@/components/price/PriceSummaryToggle';
import PriceSummaryMenu from '@/components/price/PriceSummaryMenu';
import PriceSummaryItem from '@/components/price/PriceSummaryItem';

export default {
  name: 'PriceSummary',
  components: {
    PriceSummaryToggle,
    PriceSummaryMenu,
    PriceSummaryItem
  },
  props: {
    settings: Object,
    flattendRows: Array
  },
  data() {
    return {
      showSummary: true,
      options: [
        {
          label: 'cost',
          description: 'Cost',
          unit: 'financial',
          isChecked: true,
          func: 'prices/totalCost'
        },
        {
          label: 'profit',
          description: 'Profit',
          unit: 'financial',
          isChecked: true,
          func: 'prices/profit'
        },
        {
          label: 'margin',
          description: 'Margin',
          unit: 'percentage',
          isChecked: true,
          func: 'prices/margin'
        },
        {
          label: 'hours',
          description: 'Hours',
          unit: 'time',
          isChecked: true,
          func: 'prices/totalTimeHours'
        },
        {
          label: 'days',
          description: 'Days',
          unit: 'time',
          isChecked: true,
          func: 'prices/totalTimeDays'
        },
        {
          label: 'time cost',
          description: 'Time cost',
          unit: 'financial',
          isChecked: false,
          func: 'prices/totalCostTime'
        },
        {
          label: 'materials cost',
          description: 'Material cost',
          unit: 'financial',
          isChecked: false,
          func: 'prices/totalCostMaterials'
        },
        {
          label: 'cost + markup',
          description: 'Cost + markup',
          unit: 'financial',
          isChecked: false,
          func: 'prices/totalCostIncMarkup'
        },
        {
          label: 'cost + markup + tax',
          description: 'Cost + markup + tax',
          unit: 'financial',
          isChecked: false,
          func: 'prices/totalCostIncMarkupIncTax'
        },
      ]
    }
  },
  computed: {
    ...mapState('prices', {
      price: 'price'
    }),
    availableOptions(){
      if(this.price.tax.rate > 0){
        return this.options
      }else{
        return this.options.filter(o => o.label !== 'cost + markup + tax')
      }
    },
    filteredOptions(){
      return this.availableOptions.filter(o => o.isChecked)
    }
  }
};
</script>
